module.exports = __webpack_public_path__ + "img/intereses.49569415.png";